import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from '.'

export const ConnectionContext = createContext()

export const ConnectionProvider = (props) => {
    const [isOnline, setIsOnline] = useState(true)
    const [wasOffline, setWasOffline] = useState(false)

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true)
            setTimeout(() => {
                setWasOffline(true)
            }, 100)
        }
        const handleOffline = () => {
            setIsOnline(false)
            setWasOffline(false)
        }

        window.addEventListener('online', handleOnline)
        window.addEventListener('offline', handleOffline)

        return () => {
            window.removeEventListener('online', handleOnline)
            window.removeEventListener('offline', handleOffline)
        }
    }, [])

    const provider = {
        isOnline,
        wasOffline
    }

    return <ConnectionContext.Provider value={provider} {...props} />
}

export const useConnectionContext = () => useContext(ConnectionContext)
